import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';
import { not, PrivateRoute, Roles } from '@/js/libs/use-auth';

import Status from 'src/scenes/Status';
import { Yaleo } from 'src/scenes/Yaleo';

const index = true;

export const yaleoRouteObject = inferRouteObject({
  path: 'yaleo',
  element: <PrivateRoute roles={Roles.YALEO} noAccessComponent={Status.NotFound} />,
  children: [
    {
      path: 'placements',
      children: [
        { index, Component: Yaleo.Placements.PlacementList },
        { path: ':placementUuid/:websiteId?', Component: Yaleo.Placements.PlacementManage },
      ],
    },
    {
      path: 'placements-v2',
      children: [
        { index, Component: Yaleo.PlacementsNew.PlacementList },
        {
          path: 'create',
          Component: Yaleo.PlacementsNew.PlacementManage,
        },
        { path: ':placementId', Component: Yaleo.PlacementsNew.PlacementManage },
      ],
    },
    {
      element: <PrivateRoute roles={Roles.ADMIN} noAccessComponent={Status.NotFound} />,
      children: [
        {
          path: 'crawler-configuration',
          Component: Yaleo.Websites.Layout,
          children: [
            { path: ':websiteId/manage/articles', Component: Yaleo.Websites.CrawlerConfig },
            { index, Component: Yaleo.Websites.Websites },
          ],
        },
        {
          path: '*',
          Component: Yaleo.Websites.WebsitesRedirector,
        },
      ],
    },
    {
      path: 'bta-feed',
      children: [
        { path: 'websites', Component: Yaleo.BTAFeed.Websites },
        { path: 'create/:websiteId?', Component: Yaleo.BTAFeed.LegacyForm },
        { path: 'edit/:placementUuid', Component: Yaleo.BTAFeed.LegacyForm },
        {
          path: 'v2',
          children: [
            { path: 'create', Component: Yaleo.BTAFeed.Form },
            { path: ':btaFeedId', Component: Yaleo.BTAFeed.Form },
            // Intended to replace `/yaleo/bta-feed/websites` after migration to v2.
            { index, Component: Yaleo.BTAFeed.Websites },
          ],
        },
        { index, element: <Navigate to='./websites' /> },
      ],
    },
    {
      path: 'collect',
      element: <PrivateRoute roles={not(Roles.CUSTOMER)} noAccessComponent={Status.NotFound} />,
      children: [
        { index, Component: Yaleo.Collect.CrawlerConfigsListPage },
        { path: ':crawlerConfigId/edit', Component: Yaleo.Collect.CrawlerEditConfigPage },
        { path: ':crawlerConfigId/path/:crawlerPathId', Component: Yaleo.Collect.CrawlerPathEditPage },
        { path: 'create', Component: Yaleo.Collect.CrawlerConfigPage },
      ],
    },
    {
      path: 'algorithms-config',
      element: <PrivateRoute roles={not(Roles.CUSTOMER)} noAccessComponent={Status.NotFound} />,
      children: [{ index, Component: Yaleo.AlgorithmsConfig }],
    },
    // TODO: Remove this temporary route after 14.08.2025
    {
      path: 'settings',
      element: <PrivateRoute roles={not(Roles.CUSTOMER)} noAccessComponent={Status.NotFound} />,
      children: [
        { index, element: <Navigate to='/yaleo/algorithms-config' replace /> },
        { path: '*', element: <Navigate to='/yaleo/algorithms-config' replace /> },
      ],
    },
    {
      index,
      element: <Navigate to='./websites' replace />,
    },
  ],
});
